// Auto-generated background images list
// Generated on: 2026-06-18T21:31:13.611Z
// Default (CH3): 31 images
// Per-channel pools: ch2=13, ch4=12, ch6=6, ch35=11

// Channel 3 default pool — images in /public/bg/
export const backgroundImages = [
  "/bg/20230305_160446.jpg",
  "/bg/20230310_113926.jpg",
  "/bg/20230310_170323.jpg",
  "/bg/20230311_114327~2.jpg",
  "/bg/20230415_091146.jpg",
  "/bg/20230603_095027~2.jpg",
  "/bg/20231214_174753.jpg",
  "/bg/20231220_091305.jpg",
  "/bg/20231222_135934.jpg",
  "/bg/20231224_132745.jpg",
  "/bg/20240309_174427.jpg",
  "/bg/20240601_192412.jpg",
  "/bg/20240704_201604.jpg",
  "/bg/20240805_191606.jpg",
  "/bg/20241227_162337.jpg",
  "/bg/20250104_150527-EDIT.jpg",
  "/bg/20250312_095352.jpg",
  "/bg/20250315_152239.jpg",
  "/bg/20250329_172513.jpg",
  "/bg/20250329_180257.jpg",
  "/bg/20250502_152600.jpg",
  "/bg/20250502_152748~2.jpg",
  "/bg/20250814_204013-EDIT (2).jpg",
  "/bg/20250906_194829.jpg",
  "/bg/20250908_200811.jpg",
  "/bg/20260602_120021.jpg",
  "/bg/20260603_092341.jpg",
  "/bg/20260604_121838.jpg",
  "/bg/20260604_182423.jpg",
  "/bg/20260607_224037.jpg",
  "/bg/bg.jpg"
];

// Per-channel image pools — images in /public/bg/<folder>/
// If a channel folder is empty, SimpleBackgroundManager falls back to backgroundImages.
export const channelBackgroundImages = {
  ch2:  [
  "/bg/ch2/20241013_104322.jpg",
  "/bg/ch2/20241013_125505.jpg",
  "/bg/ch2/20241109_132724.jpg",
  "/bg/ch2/20250312_102437.jpg",
  "/bg/ch2/20250312_133845.jpg",
  "/bg/ch2/20250313_135109.jpg",
  "/bg/ch2/20250315_170034.jpg",
  "/bg/ch2/20250722_194418.jpg",
  "/bg/ch2/20250911_205635.jpg",
  "/bg/ch2/20251112_094405.jpg",
  "/bg/ch2/20251112_160435.jpg",
  "/bg/ch2/20251115_135404.jpg",
  "/bg/ch2/20251129_154556.jpg"
],
  ch4:  [
  "/bg/ch4/20230728_210221.jpg",
  "/bg/ch4/20240704_202054.jpg",
  "/bg/ch4/20240706_234557.jpg",
  "/bg/ch4/20240804_203213.jpg",
  "/bg/ch4/20240805_191724.jpg",
  "/bg/ch4/20240806_204411.jpg",
  "/bg/ch4/20240811_205120.jpg",
  "/bg/ch4/20240811_205648.jpg",
  "/bg/ch4/20241206_134855.jpg",
  "/bg/ch4/20250803_175220.jpg",
  "/bg/ch4/20250804_205907.jpg",
  "/bg/ch4/20250814_204013-EDIT.jpg"
],
  ch6:  [
  "/bg/ch6/20240711_172335.jpg",
  "/bg/ch6/20240811_205640.jpg",
  "/bg/ch6/20250803_175220.jpg",
  "/bg/ch6/20250804_205532.jpg",
  "/bg/ch6/20250814_204016.jpg",
  "/bg/ch6/20260504_164525.jpg"
],
  ch35: [
  "/bg/ch35/20251225_180021.jpg",
  "/bg/ch35/20260102_191847.jpg",
  "/bg/ch35/20260104_213114.jpg",
  "/bg/ch35/20260105_200238.jpg",
  "/bg/ch35/20260207_091041.jpg",
  "/bg/ch35/20260215_000821.jpg",
  "/bg/ch35/20260218_192910.jpg",
  "/bg/ch35/20260218_193036.jpg",
  "/bg/ch35/20260321_224710.jpg",
  "/bg/ch35/20260321_224923.jpg",
  "/bg/ch35/20260329_100454.jpg"
],
};

export const getRandomImage = () =>
  backgroundImages[Math.floor(Math.random() * backgroundImages.length)];

export const getImageCount = () => backgroundImages.length;

export const getImageByIndex = (index) =>
  backgroundImages[index % backgroundImages.length];
